module.exports = __webpack_public_path__ + "img/stained-glass.3f215630.jpg";